<template>
  <div class="container mt-4 mb-5" style="max-width: 600px;">
    <div class="card shadow-sm">
      <div class="card-body p-4">
        <h4 class="card-title text-center mb-4 fw-bold">이용약관 및 개인정보 수집·이용 동의</h4>

        <!-- 약관 내용: 사용자 제공한 원문을 섹션별로 표시 -->
        <div class="terms-content mb-4 p-3 border rounded" style="background-color: #f8f9fa; max-height: 500px; overflow-y: auto; font-size: 0.95rem; line-height: 1.6;">
          <div class="mb-3" style="white-space: pre-wrap;">
            은평구시설관리공단(이하 '공단')은 거주자우선주차 서비스 제공을 위하여 개인정보 보호법 등 관계 법령에 따라 개인정보를 수집이용하거나 제3자에게 제공할 수 있습니다. 이에 개인정보 처리에 관한 사항을 아래와 같이 안내하며, 정보주체의 동의가 필요한 사항에 대해서는 각 항목별로 동의를 받고자 합니다.
          </div>

          <div class="mb-3">
            <div class="d-flex justify-content-between align-items-start">
              <strong>1. 개인정보 수집이용 안내</strong>
              <div class="d-flex align-items-center">
                <div class="form-check me-2">
                  <input class="form-check-input" type="radio" :value="true" v-model="agree1" name="agree1" id="agree1_yes" />
                  <label class="form-check-label ms-2" for="agree1_yes">동의함</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" :value="false" v-model="agree1" name="agree1" id="agree1_no" />
                  <label class="form-check-label ms-2" for="agree1_no">동의하지 않음</label>
                </div>
              </div>
            </div>
            <div class="section-body mt-2 p-2 border rounded" style="max-height:150px; overflow-y:auto; white-space: pre-wrap;">
              □ 공단은 거주자우선주차 이용 및 공영주차장 사용 신청관리를 위하여 개인정보 보호법제15조제1항에 따라 다음과 같이 개인정보를 수집이용합니다.

              <strong>【개인정보의 수집이용 목적】</strong>
              <strong>본인확인 및 개인식별, 거주자우선주차 신청자격 확인, 주차구획 배정, 주차 요금 부과납부 관리, 이용자 관리, 민원처리, 고지사항 전달 및 관련 서비스 제공</strong>

              <strong>【수집이용하는 개인정보 항목】</strong>
              <strong>성명, 생년월일, 주소, 연락처, 차량번호, 차량소유주, 차량정보, 사용희망 구획 및 사용 시간</strong>

              <strong>【개인정보의 보유 및 이용기간】</strong>
              <strong>수집된 개인정보는 회원자격 유지 기간 동안 보유이용하며, 회원탈퇴 또는 처리목적 달성 후에는 지체 없이 파기합니다.</strong> 다만, 관계 법령에 따라 보존할 필요가 있는 경우에는 해당 법령에서 정한 기간 동안 보관합니다.

              ※ 귀하는 필수적 개인정보 수집이용에 대한 동의를 거부할 권리가 있습니다. 다만, <strong>위 개인정보는 거주자우선주차 신청 및 서비스 이용에 필요한 정보이므로 동의하지 않을 경우 거주자우선주차 신청 및 서비스 이용이 제한될 수 있습니다.</strong>

              위와 같이 개인정보를 수집이용하는 데 동의하십니까?
            </div>
          </div>

          <div class="mb-3">
            <div class="d-flex justify-content-between align-items-start">
              <strong>2. 선택적 개인정보 수집이용 동의</strong>
              <div class="d-flex align-items-center">
                <div class="form-check me-2">
                  <input class="form-check-input" type="radio" :value="true" v-model="agree2" name="agree2" id="agree2_yes" />
                  <label class="form-check-label ms-2" for="agree2_yes">동의함</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" :value="false" v-model="agree2" name="agree2" id="agree2_no" />
                  <label class="form-check-label ms-2" for="agree2_no">동의하지 않음</label>
                </div>
              </div>
            </div>
            <div class="section-body mt-2 p-2 border rounded" style="max-height:150px; overflow-y:auto; white-space: pre-wrap;">
              □ 공단은 거주자우선주차 요금 감면 및 관련 서비스 제공을 위하여 다음과 같이 선택적 개인정보를 수집이용하고자 합니다.

              <strong>【개인정보의 수집이용 목적】</strong>
              <strong>거주자우선주차 요금 감면대상 확인 및 감면 적용</strong>

              <strong>【수집이용하는 개인정보 항목】</strong>
              <strong>신청인이 선택한 요금 감면대상 확인에 필요한 정보</strong>

              <strong>【개인정보의 보유 및 이용기간】</strong>
              <strong>은평구 거주자우선주차 회원자격 유지 기간까지</strong>

              ※ 귀하는 선택적 개인정보 수집이용에 대한 동의를 거부할 권리가 있습니다. <strong>동의하지 않더라도 거주자우선주차 신청 및 기본 서비스 이용에는 제한이 없으나, 해당 요금 감면 적용이 제한될 수 있습니다.</strong>

              위와 같이 개인정보를 수집이용하는 데 동의하십니까?
            </div>
          </div>

          <div class="mb-3">
            <div class="d-flex justify-content-between align-items-start">
              <strong>3. 개인정보 제3자 제공에 관한 동의</strong>
              <div class="d-flex align-items-center">
                <div class="form-check me-2">
                  <input class="form-check-input" type="radio" :value="true" v-model="agree3" name="agree3" id="agree3_yes" />
                  <label class="form-check-label ms-2" for="agree3_yes">동의함</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" :value="false" v-model="agree3" name="agree3" id="agree3_no" />
                  <label class="form-check-label ms-2" for="agree3_no">동의하지 않음</label>
                </div>
              </div>
            </div>
            <div class="section-body mt-2 p-2 border rounded" style="max-height:150px; overflow-y:auto; white-space: pre-wrap;">
              □ 공단은 거주자우선주차 이용과 관련 고객만족도 조사 및 거주자우선주차구획 공유서비스 제공을 위하여 다음과 같이 개인정보를 제3자에게 제공하고자 합니다.

              <strong>【개인정보를 제공받는 자】</strong>
              <strong>① 행정안전부 및 서울특별시 등 고객만족도 조사 관련 기관
              ② 공단 고객만족도 조사 수행기관
              ③ 은평구와 거주자우선주차 공유사업 협약을 체결한 업체</strong>

              <strong>【개인정보를 제공받는 자의 이용 목적】</strong>
              <strong>① 지방공기업 경영평가 및 고객만족도 조사
              ② 공단 고객만족도 조사 수행기관
              ③ 거주자우선주차구획 공유서비스 제공 및 이용관리</strong>

              <strong>【제공하는 개인정보 항목】</strong>
              <strong>성명, 연락처, 차량정보 등 해당 업무 수행에 필요한 최소한의 개인정보</strong>

              <strong>【개인정보를 제공받는 자의 보유이용기간】</strong>
              <strong>해당 개인정보의 제공 목적 달성 시까지</strong>

              ※ 귀하는 개인정보 제3자 제공에 대한 동의를 거부할 권리가 있습니다. <strong>동의하지 않더라도 거주자우선주차 신청 및 기본 서비스 이용에는 제한이 없으나,</strong> <strong>개인정보 제공이 필요한 고객만족도 조사 또는 공유 주차 서비스 등의 이용이 제한이 될 수 있습니다.</strong>

              위와 같이 개인정보 제3자 제공에 동의하십니까?
            </div>
          </div>

          <!-- 섹션 4 -->
          <div class="mb-3">
            <div class="d-flex justify-content-between align-items-start">
              <strong>4. 행정정보 공동이용 사전동의</strong>
              <div class="d-flex align-items-center">
                <div class="form-check me-2">
                  <input class="form-check-input" type="radio" :value="true" v-model="agree4" name="agree4" id="agree4_yes" />
                  <label class="form-check-label ms-2" for="agree4_yes">동의함</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" :value="false" v-model="agree4" name="agree4" id="agree4_no" />
                  <label class="form-check-label ms-2" for="agree4_no">동의하지 않음</label>
                </div>
              </div>
            </div>
            <div class="section-body mt-2 p-2 border rounded" style="max-height:150px; overflow-y:auto; white-space: pre-wrap;">
              □ 본인은 공단이 거주자우선주차 이용 및 기타 거주자우선주차 운영 업무수행과 관련하여 「서울특별시 은평구 주차장설치 및 관리조례」 및 이에 근거한 「거주자우선주차 운영지침」에 근거한 주차구획 신설(배정) 신청 자격과 요금 감면사항 확인을 위해 「전자정부법」 제36조에 따른 행정정보의 공동이용을 통해 아래의 구비서류 항목에 대해 업무처리 담당자가 전자적으로 확인하는 것에 동의합니다.

              <strong>【민원(고객)사무의 명칭】</strong>
              <strong>「거주자우선 주차구획 신청」, 「기존회원 자격 및 요금감면 점검」</strong>

              <strong>【전자 확인 가능 구비서류 항목】</strong>
              <strong>① 주민등록초(등)본, ② 자동차등록증, ③ 유공자증, ④ 장애인증명서, ⑤ 장애인전용주차구역 주차표지, ⑥ 자원봉사자카드, ⑦ 임신확인서, ⑧ 한부모 복지급여 지원대상자 증명서, ⑨ 국가보훈등록증, ⑩ 병역명문가증 등</strong>

              ※ 귀하는 행정정보 공동이용에 동의하지 않을 권리가 있습니다. <strong>동의하지 않는 경우 해당 구비서류를 직접 제출하여야 합니다.</strong>

              위와 같이 행정정보 공동이용에 동의하십니까?
            </div>
          </div>

          <!-- 섹션 5 -->
          <div class="mb-3">
            <strong>5. 개인정보 처리업무 위탁 안내</strong>
            <div class="section-body mt-2 p-2 border rounded" style="max-height:150px; overflow-y:auto; white-space: pre-wrap;">
              □ 공단은 원활한 거주자우선주차 서비스 제공을 위하여 개인정보 처리업무의 일부를 다음과 같이 위탁하고 있습니다.

              <strong>【수탁자】</strong>
              <strong>아이티에스엔지니어</strong>

              <strong>【위탁업무의 내용】</strong>
              <strong>거주자우선주차 시스템 운영 및 유지관리</strong>

              <strong>【위탁기간】</strong>
              <strong>위탁계약 종료 시까지</strong>

              ※ 공단은 개인정보 보호법 제26조에 따라 수탁자가 개인정보를 안전하게 처리하도록 필요한 사항을 계약서 등에 명시하고 관리감독하고 있습니다.
            </div>
          </div>

        </div>

        <div class="mb-4 border-top pt-3 d-flex gap-2">
          <button class="btn btn-outline-secondary" @click="toggleAgreeAll" :disabled="allChecked">전체 동의</button>
          <button class="btn btn-primary ms-auto" :disabled="!allChecked" @click="goNext">다음</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MembershipTerms',
  data() {
    return {
      agree1: null,
      agree2: null,
      agree3: null,
      agree4: null,
      agree5: null
    }
  },
  computed: {
    allChecked() {
      return this.agree1 === true && this.agree3 === true && this.agree4 === true && this.agree5 === true
    }
  },
  methods: {
    toggleAgreeAll() {
      const target = true
      this.agree1 = target
      this.agree2 = target
      this.agree3 = target
      this.agree4 = target
      this.agree5 = target
    },
    goNext() {
      if (!this.allChecked) {
        alert('모든 항목에 동의하셔야 다음으로 진행할 수 있습니다.')
        return
      }
      this.$router.push('/register')
    }
  }
}
</script>

<style scoped>
.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.form-check-input:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
</style>
